import { tabProps } from "@/utils/globalPropsTypes";
import { Form, InputNumber, Radio, Select } from "antd";

function GaugeTab({ editItem }) {
  const { component } = editItem;
  return (
    <>
      {["tank"].includes(component) && (
        <>
          <Form.Item name="capacity" getValueFromEvent={(value) => (value ? value : 1)} label="Capacity">
            <InputNumber placeholder="Input Capacity" min={1} className="w-100" />
          </Form.Item>
        </>
      )}

      {["dial"].includes(component) && (
        <>
          <Form.Item
            name="dialType"
            initialValue="props"
            label="Gauge Design Type"
            rules={[{ required: true, message: "Gauge Type" }]}
          >
            <Select
              style={{ width: "100%" }}
              placeholder="Gauge Design Type"
              options={[
                { label: "Default Gauge", value: "props" },
                { label: "Simple Gauge", value: "simple" },
                { label: "Gradient Arc Gauge", value: "gradient" },
                { label: "Temperature Gauge", value: "temperature" },
                // { label: "Gauge Chart With Default Props", value: "props" },
                { label: "Gauge Chart With 20 Levels", value: "levels" },
                { label: "Gauge Chart With Custom Colors", value: "custom" },
              ]}
            />
          </Form.Item>
        </>
      )}

      {["dial", "thermometer"].includes(component) && (
        <>
          <Form.Item
            name="min"
            initialValue={0}
            getValueFromEvent={(value) => (Number(value) >= 0 ? value : undefined)}
            label="Enter Min Value"
            rules={[{ required: true, message: "Please Input Min" }]}
          >
            <InputNumber placeholder="Input Min Value" min={0} className="w-100" />
          </Form.Item>
          <Form.Item
            name="max"
            initialValue={100}
            getValueFromEvent={(value) => (value ? value : undefined)}
            label="Enter Max Value"
            rules={[{ required: true, message: "Please Input Max" }]}
          >
            <InputNumber placeholder="Input Max Value" min={0} className="w-100" />
          </Form.Item>
        </>
      )}

      {["thermometer"].includes(component) && (
        <>
          <Form.Item name="unit" label="Unit" initialValue="celsius">
            <Radio.Group>
              <Radio value="celsius">Celsius</Radio>
              <Radio value="fahrenheit">Fahrenheit</Radio>
            </Radio.Group>
          </Form.Item>
        </>
      )}
    </>
  );
}

export default GaugeTab;

GaugeTab.propTypes = tabProps;
